import React, { Fragment, useEffect, useState } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import SearchIcon from "@mui/icons-material/Search";

import {
  CircularProgress,
  createTheme,
  Divider,
  Grid,
  Paper,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

import CustomDrawer from "../../components/drawer/drawer.component";
import MetricBoxComponent from "../../components/orders/metricBox.component";
import "./schemes.styles.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#a36e29",
    },
  },
  typography: {
    fontFamily: '"Work Sans", sans-serif',
  },
});

const formatAmount = (amt) => `₹ ${parseFloat(amt || 0).toLocaleString()}`;

const SchemesComponent = () => {
  const admin = JSON.parse(localStorage.getItem("admin"));
  const navigate = useNavigate();

  const [schemesList, setSchemesList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loadingTransaction, setLoadingTransaction] = useState(false);
  const [search, setSearch] = useState("");

  const [stats, setStats] = useState({
    total_schemes: 0,
    total_active: 0,
    total_inactive: 0,
    total_paid: 0,
  });

  useEffect(() => {
    if (!admin?.token) return;
    const fetchSchemes = async () => {
      try {
        const params = new URLSearchParams({
          status: "active",
          page: "1",
          limit: "10",
        });
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}v2.0.0/admin/schemes/enrollments.php?${params}`,
          {
            headers: {
              Authorization: `Bearer ${admin.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (data.success === true) {
          const response = data.data?.enrollments || [];
          setSchemesList(response);
          setStats({
            total_schemes: response.length,
            total_active: response.filter((s) => s.status === "active").length,
            total_inactive: response.filter((s) => s.status !== "active")
              .length,
            total_paid: response.reduce(
              (acc, cur) =>
                acc + parseFloat(cur.payment_summary?.total_paid_amount || 0),
              0
            ),
            //   total_paid: response.reduce(
            //     (acc, cur) => acc + response.payment_summary?.total_paid_amount || 0)
            // });
          });
        }
      } catch (err) {
        console.error("Error fetching schemes:", err);
      }
    };
    fetchSchemes();
  }, [admin?.token]);

  const fetchTransactionDetails = async (scheme) => {
    setSelectedScheme(scheme);
    setLoadingTransaction(true);
    try {
      const params = new URLSearchParams({
        status: "active",
        page: "1",
        limit: "10",
      });
      const { data } = await axios.get(
        {
          /*`https://api.sadashrijewelkart.com/v2.0.0/admin/schemes/transactions.php?subscription=${scheme.id}`*/
        }`${process.env.REACT_APP_API_URL}v2.0.0/admin/schemes/enrollments.php?${params}`,
        {
          headers: {
            Authorization: `Bearer ${admin.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setSelectedTransaction(
        data.success === true && data.data.enrollments.length > 0
          ? data.data?.enrollments
          : null
      );
    } catch (error) {
      console.error("Failed to fetch transaction details:", error);
      setSelectedTransaction(null);
    } finally {
      setLoadingTransaction(false);
      setDialogOpen(true);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredSchemes = schemesList.filter((scheme) => {
    const term = search.toLowerCase().trim();
    if (!term) return true;

    return (
      scheme.scheme_id?.toLowerCase().includes(term) ||
      scheme.user_id?.toString().includes(term) ||
      scheme.status?.toLowerCase().includes(term) ||
      scheme.scheme_name?.toLowerCase().includes(term)
    );
  });

  return (
    <div className="product">
      <CustomDrawer section="schemes" />
      <Divider orientation="vertical" flexItem className="divider" />

      <div className="category-component">
        <ToastContainer />

        <ThemeProvider theme={theme}>
          <SwipeableDrawer
            anchor="right"
            open={showDrawer}
            onClose={() => setShowDrawer(false)}
            onOpen={() => setShowDrawer(true)}
          />
        </ThemeProvider>

        <div className="head">
          <div className="head-txt">Scheme Subscriptions</div>
        </div>

        <Grid
          container
          spacing={3}
          sx={{ width: "100%", height: 300, pl: 3, mb: 3 }}
        >
          <Grid item xs={3}>
            <MetricBoxComponent
              heading="Total Subscriptions"
              metric={stats.total_schemes.toString()}
            />
          </Grid>
          <Grid item xs={3}>
            <MetricBoxComponent
              heading="Active Subscriptions"
              metric={stats.total_active.toString()}
            />
          </Grid>
          <Grid item xs={3}>
            <MetricBoxComponent
              heading="Inactive Subscriptions"
              metric={stats.total_inactive.toString()}
            />
          </Grid>
          <Grid item xs={3}>
            <MetricBoxComponent
              heading="Total Paid"
              metric={`₹ ${stats.total_paid}`}
            />
          </Grid>
        </Grid>

        <Divider />

        <Box 
        sx = {{
          display: 'flex',
          flexDirection: 'row',
          float: 'right',
          margin: '10px',
          marginRight: '35px',
          height: '40px',
          width: '250px',
          boxShadow: 2,
        }}
        >

          <SearchIcon
          sx = {{
            display: 'flex',
            justifyContent: 'center',
            margin: '5px',
            marginTop: '8px',
          }}
          ></SearchIcon>

         <input style = {{
          display: 'flex',
          border: 'none',
          outline: 'none',
          backgroundColor: 'transparent',
          fontSize: '20px',
          
          }}
          placeholder="Search Schemes"
          onChange={(e) => setSearch(e.target.value)}
          value = {search}
          ></input>

        </Box>

        <Divider />

        <ThemeProvider theme={theme}>
          <Paper
            sx={{
              width: "95%",
              overflow: "hidden",
              height: "50vh",
              m: "30px 25px",
              borderRadius: 2,
              boxShadow: 1,
              pl: 1,
            }}
          >
            {schemesList.length === 0 ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <CircularProgress />
              </Box>
            ) : filteredSchemes.length === 0 ? ( // ✅ Handle "no match" case
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Typography 
                sx = {{
                  fontSize: 20,
                }}
                >
                  No matching schemes found.
                </Typography>
              </Box>
            ) : (
              <TableContainer sx={{ height: "90%" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>User ID</TableCell>
                      <TableCell>Scheme ID</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Start Date</TableCell>
                      {/*<TableCell>Exp. Closure</TableCell>*/}
                      <TableCell>Total Paid</TableCell>
                      <TableCell>Installments Paid</TableCell>
                      {/*<TableCell>Plan</TableCell>*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredSchemes
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => (
                        <TableRow
                          key={row.id}
                          hover
                          onClick={() => fetchTransactionDetails(row)}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{row.user_id}</TableCell>
                          <TableCell>{row.scheme_id}</TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 800,
                              color: row.status === "active" ? "green" : "red",
                            }}
                          >
                            {row.status.charAt(0).toUpperCase() +
                              row.status.slice(1)}
                          </TableCell>
                          <TableCell>
                            {new Date(row.enrollment_date).toLocaleDateString()}
                          </TableCell>
                          {/*
                        <TableCell>
                          {row.exp_closure_date === "0000-00-00 00:00:00"
                            ? "N/A"
                            : new Date(row.exp_closure_date).toLocaleDateString()}
                        </TableCell>
                        */}
                          <TableCell>
                            ₹ {row.payment_summary?.total_paid_amount}
                          </TableCell>
                          <TableCell>
                            {row.payment_summary?.paid_installments}
                          </TableCell>
                          {/*<TableCell>{row.plan}</TableCell>*/}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={filteredSchemes.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </ThemeProvider>

        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle sx={{ pb: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                pr: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton
                  onClick={() => setDialogOpen(false)}
                  edge="start"
                  sx={{ mr: 1 }}
                >
                  <CloseIcon />
                </IconButton>
                <Box>
                  <Typography fontWeight="bold" variant="h6">
                    {selectedScheme?.scheme_name || "Scheme Name"}
                  </Typography>
                  <Typography fontSize="0.9rem" color="text.secondary">
                    {selectedScheme?.start_date || "Start Date"} –{" "}
                    {selectedScheme?.exp_closure_date || "Maturity Date"}
                  </Typography>
                </Box>
              </Box>

              <Box textAlign="right">
                <Chip
                  label={
                    selectedScheme?.status.charAt(0).toUpperCase() +
                      selectedScheme?.status.slice(1) || "In Progress"
                  }
                  size="small"
                  sx={{
                    backgroundColor:
                      selectedScheme?.status === "active"
                        ? "#4caf50"
                        : "#f57c00",
                    color: "white",
                    fontWeight: "bold",
                    mb: 0.5,
                  }}
                />
                <Typography fontSize="0.9rem">
                  <b>Total Payment:</b>{" "}
                  {formatAmount(
                    selectedScheme?.payment_summary?.total_paid_amount || 0
                  )}
                </Typography>
              </Box>
            </Box>
          </DialogTitle>
          <Divider />

          <Divider />

          <DialogContent sx={{ mt: 2 }}>
            <Typography variant="h6" fontWeight="bold" mb={2}>
              Transaction History
            </Typography>

            {selectedScheme ? (
              <Box
                sx={{
                  //display: "flex",
                  // flexDirection: "column",
                  // gap: 1.5,
                  // backgroundColor: "#f9f9f9",
                  // borderRadius: 2,
                  p: 2,
                  backgroundColor: "#FFFDF8",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#FBFBFB",
                    boxShadow: 1,
                    margin: 2,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1, fontSize: 20 }}
                  >
                    Payment Summary
                  </Typography>

                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <Typography sx={{ fontSize: 19 }}>
                        Paid:{" "}
                        {selectedScheme.payment_summary?.paid_installments}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ fontSize: 19 }}>
                        Pending:{" "}
                        {selectedScheme.payment_summary?.pending_installments}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ fontSize: 19 }}>
                        Total Paid: ₹
                        {selectedScheme.payment_summary?.total_paid_amount}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#FBFBFB",
                    boxShadow: 1,
                    margin: 2,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1, color: "#2C2C2C" , fontSize: 20}}
                  >
                    Key Highlights
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 19 }}>
                        Instalment Amount
                      </Typography>
                      <Typography variant="body1" fontWeight={600} sx={{ fontSize: 19 }}>
                        ₹{selectedScheme.instalment_amount}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 19 }}>
                        Total Amount
                      </Typography>
                      <Typography variant="body1" fontWeight={600}>
                        ₹{selectedScheme.total_amount}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="body2" color="text.secondary">
                        Progress
                      </Typography>
                      <LinearProgress
                        variant="determinate"
                        value={selectedScheme.progress?.percentage}
                        sx={{
                          height: 6,
                          borderRadius: 3,
                          backgroundColor: "#F1E3B0",
                          "& .MuiLinearProgress-bar": {
                            backgroundColor: "#C9A23C",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#FBFBFB",
                    boxShadow: 1,
                    margin: 2,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1, fontSize: 20 }}
                  >
                    Scheme Details
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: 17 }}>
                    <b>Type:</b>{" "}
                    {selectedScheme.scheme_type.charAt(0).toUpperCase() +
                      selectedScheme.scheme_type.slice(1)}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: 17 }}>
                    <b>Tenure:</b> {selectedScheme.tenure_days} days
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: 17 }}>
                    <b>Reward:</b> {selectedScheme.completion_reward}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#555", mt: 1, fontSize: 15 }}
                  >
                    {selectedScheme.scheme_description}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#FBFBFB",
                    boxShadow: 1,
                    margin: 2,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1, fontSize: 20 }}
                  >
                    Timeline
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography sx={{ fontSize: 19 }}>
                        Enrolled: {selectedScheme.enrollment_date}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ fontSize: 19 }}>
                        Next Due: {selectedScheme.next_due_date}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ fontSize: 19 }}>
                        Completion: {selectedScheme.completion_date || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography sx={{ fontSize: 19 }}>
                        Updated: {selectedScheme.updated_at}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: "#FBFBFB",
                    boxShadow: 1,
                    margin: 2,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1, fontSize: 20 }}
                  >
                    Bonus & Gold
                  </Typography>
                  <Typography sx={{ fontSize: 19 }}>
                    Bonus Earned: ₹{selectedScheme.bonus_earned}
                  </Typography>
                  <Typography sx={{ fontSize: 20 }}>
                    {selectedScheme.scheme_id === "10-month-accumulation" && (
                      <>
                        <strong>Gold Accumulated:</strong> ₹{" "}
                        {(() => {
                          try {
                            const rateData = JSON.parse(
                              selectedScheme.gold_grams_accumulated
                            );
                            return rateData.toFixed(3) || 0;
                          } catch {
                            return "N/A";
                          }
                        })()}{" "}
                        gm
                      </>
                    )}
                  </Typography>
                </Box>
              </Box>
            ) : loadingTransaction ? (
              <Box textAlign="center">
                <CircularProgress />
              </Box>
            ) : (
              <Typography>Transaction data not found.</Typography>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default SchemesComponent;
